import { createFeatureSelector } from '@ngrx/store';
import type { AuthStateV2 } from './auth-v2.reducer';
import { AUTH_FEATURE_KEY_V2 } from './auth-v2.reducer';

export const getAuthStateV2 = createFeatureSelector<AuthStateV2>(AUTH_FEATURE_KEY_V2);

export function canPreviewArticle(auth: AuthStateV2): boolean {
  if (auth.isLoggedIn === false) {
    return false;
  }
  return auth.userData.permissions.PreviewArticle;
}
